<template>
    {{ formattedDescription }}
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            description: {
                type: Object,
                required: true,
            },
        },

        methods: {
            formatClubDescription() {
                return this.description?.[0].name;
            },

            formatToeEngravingDescription() {
                const stamp = this.description.find((item) => item.placementCode === 'Stamp')?.name;
                const color = this.description.find((item) => item.placementCode === 'StampColor')?.name;

                return `${stamp} | Color: ${color}`;
            },

            formatPaintfillDescription() {
                const loftColor = this.description.find((item) => item.placementCode === 'StampingColorsLoft')?.name;
                const bounceColor = this.description.find((item) => item.placementCode === 'StampingColorsBounce')?.name;
                const grindColor = this.description.find((item) => item.placementCode === 'StampingColorsGrind')?.name;
                const wingColor = this.description.find((item) => item.placementCode === 'StampingColorsWing')?.name;

                let description = '';

                if (loftColor) {
                    description += `Loft: ${loftColor} | `;
                }

                if (bounceColor) {
                    description += `Bounce: ${bounceColor} | `;
                }

                if (grindColor) {
                    description += `Grind: ${grindColor} | `;
                }

                if (wingColor) {
                    description += `Wing: ${wingColor} | `;
                }

                return description.slice(0, -2);
            },

            formatCharacterStampingDescription() {
                const stampingStyle = this.description[0]?.name;

                const characters = this.description[1]?.name;

                const colors = this.description.find((item) => item.placementCode === 'StampingColorsLines')?.name;

                return `${stampingStyle} | ${characters}: ${colors}`;
            },

            formatSpecificationsDescription() {
                return '';
            },
        },

        computed: {
            formattedDescription() {
                if (!this.description) {
                    return '';
                }

                const { category } = this.description[0];

                switch (category) {
                case 'Wedge':
                    return this.formatClubDescription();

                case 'Color Changes': // Paintfill
                    return this.formatPaintfillDescription();

                case 'Toe Engraving':
                    return this.formatToeEngravingDescription();

                case 'Stamping': // Character Stamping
                    return this.formatCharacterStampingDescription();

                case 'Specifications':
                    return this.formatSpecificationsDescription();

                default: {
                    const names = this.description.map((x) => x.name);

                    return names.join(' | ');
                }
                }
            },
        },

    };
</script>
